import { TutorIdentityOrb } from '../content/tutor-media'
import type { FeedbackSummary } from './api'

export function FeedbackCoach({summary,compact=false,children}:{summary:Pick<FeedbackSummary,'tutor'|'tutorContentKey'>;compact?:boolean;children?:React.ReactNode}):JSX.Element {
  return <div className="flex items-center gap-2">
    {summary.tutor && <TutorIdentityOrb contentKey={summary.tutorContentKey??''} name={summary.tutor} size={compact?32:48} />}
    <div data-feedback-coach-content className="min-w-0">{children??<span>{summary.tutor??'Coach not recorded'}</span>}</div>
  </div>
}
